import React, { useEffect, useState } from 'react';
import { MultiSelect } from "react-multi-select-component";
import { ToastContainer, toast } from "react-toastify";
import { saveToplevelprogram, updateToplevelprogram } from '../../../services/CommonService';
import FileBase64 from 'react-file-base64';

const AddToplevelprogram = ({ tenantprops, updateprop }) => {

    const notifyTopFullWidth = (message) => {
        toast.info(message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };
    const [selected, setSelected] = useState([]);
    const options = [
        { label: "tdpyuva", value: "7e71674b" }
    ];

    const fields = {
        displayposition: '',
        status: '',
        description: '',
        name: '',
        base64: '',
        tenant: []

    }

    const errors = {
        displayposition: '',
        status: '',
        description: '',
        name: '',
        base64: '',


    }

    const [errorFields, setErrorFields] = useState(errors);
    const [formfields, setFromFields] = useState(fields);
    const [filefields, setFileFields] = useState(null);
    const [imageShow, setImageshow] = useState(false);

    useEffect(() => {
        //getBanner();
        if (updateprop?.id) {
            setFromFields(updateprop);
            setSelected(updateprop.tenant);
            setFileFields(updateprop.image);
            setImageshow(true);

        }
    }, []);

    const { displayposition, name, status, description } = formfields;

    const validateForm = async () => {
        let fields = formfields;
        let errors = {};
        let formIsValid = true;

        if (!fields["displayposition"]) {
            formIsValid = false;
            errors["displayposition"] = "*Please display position .";
        }

        if (!fields["name"]) {
            formIsValid = false;
            errors["name"] = "*Please enter category name .";
        }

        if (!fields["description"]) {
            formIsValid = false;
            errors["description"] = "*Please enter description .";
        }
        if (!fields["status"]) {
            formIsValid = false;
            errors["status"] = "*Please select status .";
        }

        if (filefields == null) {
            errors["base64"] = "*Please choose banner file .";
        }

        setErrorFields(errors)
        return formIsValid;

    }

    function handleChangeFile(files) {
        console.log(files);
        setFileFields(files[0]);
        if (files[0].type === 'image/png' || files[0].type === 'image/jpeg' || files[0].type === 'image/jpg') {
            let sz = files[0].size.split(' ');
            if (sz[0] > 200) {
                toast('File size should be below 200 kb', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                setFileFields(files[0].base64);
                //setImageShow(files[0].base64);
                setImageshow(true);
            }
        } else {
            toast('Please upload only png or jpg', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
        //setFile(event.target.files[0])
    }

    const submitForm = async () => {
        console.log(selected);
        const isValid = await validateForm();
        if (isValid) {
            formfields.tenant = selected;
            formfields.image = filefields;
            if (!formfields.id) {
                //save
                const Response = await saveToplevelprogram(formfields);
                if (Response.data.id) {
                    notifyTopFullWidth("Data saved successfully");
                    formfields.id = Response.data.id;
                }

            } else {
                //update
                const Response = await updateToplevelprogram(formfields);
                if (Response.data.id) {
                    notifyTopFullWidth("Data updated successfully");
                    formfields.id = Response.data.id;
                }
            }

        }
    }

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFromFields((prevState) => ({
            ...prevState,
            [name]: value
        }));

    }




    return (
        <>
            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
            <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                    Display position
                </label>
                <div className="col-lg-6">
                    <input component="input"
                        placeholder="Display position"
                        name="displayposition"
                        className="form-control"

                        value={displayposition} maxLength={50} onChange={handleChange} />

                </div>
                <div className="errorMsg">{errorFields.displayposition}</div>
            </div>
            <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                     Name
                </label>
                <div className="col-lg-6">
                    <input component="input"
                        placeholder="Name"
                        name="name"
                        className="form-control"
                        value={name} maxLength={300} onChange={handleChange} />

                </div>
                <div className="errorMsg">{errorFields.name}</div>
            </div>
            <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                    Tenants
                </label>
                <div className="col-lg-6">
                    <MultiSelect
                        options={tenantprops}
                        value={selected}
                        onChange={setSelected}
                        labelledBy="Select"
                    />

                </div>
            </div>

            <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                  Description
                </label>
                <div className="col-lg-6">
                    <textarea
                        rows={4}
                        className="form-control"
                        name="description"
                        placeholder="Description"
                        id="comment"
                        onChange={handleChange}
                        value={description}
                    />

                </div>
                <div className="errorMsg">{errorFields.description}</div>
            </div>


            <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                    Status
                </label>
                <div className="col-lg-6">
                    <select
                        className="form-control" name='status'
                        onChange={handleChange} value={status}>
                        <option value="">Select Status</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                    </select>

                </div>
                <div className="errorMsg">{errorFields.status}</div>
            </div>

            <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                     Image 
                </label>
                <div className="custom-file">
                    <FileBase64
                        multiple={true}
                        onDone={handleChangeFile} />
                </div>
                <div className="errorMsg">{errorFields.base64}</div>
            </div>

            <br />
            {imageShow && <> <div className="form-group mb-3 row">
                <label
                    className="col-lg-4 col-form-label"
                    htmlFor="val-username"
                >
                    Uploaded Image
                </label>
                <img src={filefields} alt="Red dot" />

            </div> </>}
            <br />

            <div className="form-group">
                <button onClick={submitForm} className="btn btn-primary" type="button"
                >Save</button>
            </div>
        </>
    )

}

export default AddToplevelprogram